import React from 'react';
import { cn } from '../../lib/utils';

const LoadingSpinner = React.forwardRef(({ className, size = 'default', ...props }, ref) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    default: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };
  
  return (
    <div
      ref={ref}
      className={cn(
        "animate-spin rounded-full border-2 border-muted border-t-primary",
        sizeClasses[size],
        className
      )}
      {...props}
    />
  );
});
LoadingSpinner.displayName = 'LoadingSpinner';

export { LoadingSpinner };